module.exports = __webpack_public_path__ + "toolkit-entypo.b0c571e03dc41350002a.ttf";


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/assets/fonts/toolkit-entypo.ttf
// module id = ../../../../../src/assets/fonts/toolkit-entypo.ttf
// module chunks = 3